import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

// 获取公司列表
export const getCompanyListApi = () => $http.get('/admin/coupon_lots/getCompanyList')

// 获取群通知列表
export const getGroupMsgList = (params: object = {}) => $http.get('/admin/brands/get_sync_msg_list', params)

// 向商户群发通知
export const sendGroupMsg = (data: object) => $http.post('/admin/brands/batchSendMsgs', data)

/**
 * 获取培训资料列表
 * title：课程标题
 * file_type：课程类型，0-全部，1-视频，2-文档
 * */
export const getTrainingListApi = (params: object) => $http.post('/admin/shops/get_shop_course_list', params)
/**
 * 删除、查看培训资料接口
 * id：要删除或查看的课程 ID
 * type：操作类型，1-删除，2-查看
 * */
export const delOrShowTrainingApi = (params: object) => $http.post('/admin/shops/do_shop_course', params)

/**
 * 保存培训课程
 * */
export const saveTrainingApi = (data: object) => $http.post('/admin/shops/upload_shop_course', { trains_info: data })

/**
 * 修改培训课程排序
 * */
export const updateTrainingSortApi = (id: number, sort: number) => $http.post('/admin/shops/up_sort', { id, sort })

//获取规范列表
export const getStandardListApi = (params: object = {}) => $http.get('/admin/shops/get_shop_rulelist',params)

//后台通知撤回终止
export const revocationMsgApi = (params: object = {}) => $http.get('/admin/Shops/revocationMsg',params)

/**
 * 编辑规范接口
 * */
export const  saveStandardApi= (params: object) => $http.post('/admin/shops/do_shop_rule', params)

//获取规范内容
export const getStandardApi = (id: any) => $http.get('/admin/shops/get_shop_rule_detail',{id})

// 传递版本号
export const updateVersionApi= (rule_id:any) => $http.post('/admin/shops/do_auth_rules', {rule_id})

// 获取当前用户绑定 openid 列表
export const getAccountBindApi = (obj: object) => $http.get('/admin/shops/get_shop_openids', obj)

// 解除绑定 openid
export const unbindOpenidApi= (id: number) => $http.post('/admin/shops/unbind_shop_openid', {id})
//获取站内信列表
export const getShopMailListApi = (params: object = {}) => $http.get('/ptapi/Brand/get_shop_mail_list',params)
/**
 * 编辑站内信接口
 * */
export const saveShopMailApi= (params: object) => $http.post('/ptapi/Brand/send_brand_mail', params)
//获取站内信内容
export const getShopMailApi = (id: any,is_red:number) => $http.get('/ptapi/Brand/get_shopmail_info',{id, is_red})
//获取评级列表
export const getGardListApi = (params: object = {}) => $http.get('/ptapi/Brand/get_shop_gradelist',params)

// 获取商户列表
export const getShopUserListApi = (params: object = {}) => $http.get('/admin/shop_product/getShopList', params)